module.exports = __webpack_public_path__ + "static/img/job_8.e3da7abe.png";